import { Slider } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';

import { colorUsage, getSpacing } from 'stylesheetB2c';

const CONTROL_BAR_HEIGHT = getSpacing(8);
export const SLIDER_HEIGHT = '3px';
const CONTROLS_LATERAL_PADDING = '2%';
const VOLUME_SLIDER_WIDTH = getSpacing(13);
const TRANSITION_DURATION = '0.5s';
const CONTROLS_BACKGROUND_OVERLAY_HEIGHT = getSpacing(40);
export const CONTROLS_BACKGROUND_OVERLAY_Z_INDEX = 1;
const CONTROLS_CONTAINER_Z_INDEX = CONTROLS_BACKGROUND_OVERLAY_Z_INDEX + 1;
export const VOLUME_SLIDER_CONTAINER_CLASS = 'volumeSliderContainer';

export const ControlBarContainer = styled.div`
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  left: 0;
  bottom: 0;
  height: ${CONTROL_BAR_HEIGHT};
  padding: 0 ${CONTROLS_LATERAL_PADDING};

  /* Setting width to 0 and min-width to 100% is a trick to
  let the parent container width be set by the background image
  and then display the control bar on the full width of this parent
  container
  https://stackoverflow.com/questions/55040250/how-to-match-width-of-text-to-width-of-dynamically-sized-image-title
  */
  width: 0;
  min-width: 100%;
`;
ControlBarContainer.displayName = 'ControlBarContainer';

export const VolumeArea = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    /* We need a class to add style on element parent hover */
    /* stylelint-disable-next-line selector-max-class */
    .${VOLUME_SLIDER_CONTAINER_CLASS} {
      width: ${VOLUME_SLIDER_WIDTH};
      transition: width ${TRANSITION_DURATION};
      visibility: visible;
    }
  }
`;

export const VolumeSlider = muiStyled(Slider)(() => ({
  root: {
    width: '80%',
  },
  track: {
    backgroundColor: colorUsage.mp3KbpPlayer.sliderTrackAndThumbColor,
    height: SLIDER_HEIGHT,
  },
  thumb: {
    backgroundColor: colorUsage.mp3KbpPlayer.sliderTrackAndThumbColor,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  rail: {
    backgroundColor: colorUsage.mp3KbpPlayer.sliderRailColor,
  },
}));

export const ControlsContainer = styled.div`
  width: 100%;
  height: calc(${CONTROL_BAR_HEIGHT} - ${SLIDER_HEIGHT});
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: ${CONTROLS_CONTAINER_Z_INDEX};
`;
ControlsContainer.displayName = 'ControlsContainer';

export const ControlsGroup = styled.div`
  display: flex;
  align-items: center;
`;
ControlsGroup.displayName = 'ControlsGroup';

export const VolumeSliderContainer = styled.div`
  width: 0;
  visibility: hidden;
  transition: width ${TRANSITION_DURATION}, visibility ${TRANSITION_DURATION};
  height: ${getSpacing(3)};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-right: ${getSpacing(2)};
`;
VolumeSliderContainer.displayName = 'VolumeSliderContainer';

export const ControlsBackgroundOverlay = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${CONTROLS_BACKGROUND_OVERLAY_HEIGHT};
  z-index: ${CONTROLS_BACKGROUND_OVERLAY_Z_INDEX};
  background: linear-gradient(
    to top,
    ${colorUsage.mp3KbpPlayer.controlsBackgroundColor},
    transparent
  );
`;
ControlsBackgroundOverlay.displayName = 'ControlsBackgroundOverlay';
